import dropVideo from "@/assets/drop-curtains-in-action.mp4.asset.json";
import dropWebm from "@/assets/drop-curtains-watch.webm.asset.json";
import sunbrellaWebm from "@/assets/sunbrella-fabric-watch.webm.asset.json";
import sunbrellaVideo from "@/assets/sunbrella-outdoor-how-its-made.mp4.asset.json";
import dropPoster from "@/assets/drop-curtains-video-poster.jpg.asset.json";
import sunbrellaPoster from "@/assets/sunbrella-video-poster.jpg.asset.json";
import { canonicalLink, canonicalUrl } from "@/lib/seo";
import { videoObjectScript } from "@/lib/videoJsonLd";

export const watchVideos = {
  curtains: {
    path: "/videos/drop-curtains",
    name: "Drop Curtains in Action",
    description: "Watch a Texas Made Shade installer demonstrate a custom mesh drop curtain on a Texas patio.",
    src: dropWebm.url,
    originalSrc: dropVideo.url,
    poster: dropPoster.url,
    width: 1248,
    height: 1664,
    duration: "PT5.042S",
    uploadDate: dropVideo.created_at,
    credit: "Video by Texas Made Shade & Covers.",
    servicePath: "/curtains",
    serviceLabel: "Outdoor curtains & drop panels",
  },
  sunbrella: {
    path: "/videos/sunbrella-fabric",
    name: "How Sunbrella® Outdoor Fabric Is Made",
    description: "Watch how Sunbrella® outdoor fabric is manufactured, from acrylic fiber to finished fabric. Video courtesy of Glen Raven, Inc.",
    src: sunbrellaWebm.url,
    originalSrc: sunbrellaVideo.url,
    poster: sunbrellaPoster.url,
    width: 1080,
    height: 1080,
    duration: "PT1M18.579S",
    uploadDate: sunbrellaVideo.created_at,
    creatorName: "Glen Raven, Inc.",
    credit: "Video courtesy of Glen Raven, Inc. Sunbrella® is a registered trademark of Glen Raven, Inc.",
    servicePath: "/residential-awnings",
    serviceLabel: "Residential awnings",
  },
} as const;

export type WatchVideo = (typeof watchVideos)[keyof typeof watchVideos];

export function watchVideoHead(video: WatchVideo) {
  const title = `${video.name} — Watch | Texas Made Shade`;
  return {
    links: [canonicalLink(video.path)],
    meta: [
      { title },
      { name: "description", content: video.description },
      { name: "robots", content: "index, follow, max-image-preview:large, max-video-preview:-1" },
      { property: "og:title", content: title },
      { property: "og:description", content: video.description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonicalUrl(video.path) },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: video.description },
    ],
    scripts: [videoObjectScript({
      path: video.path,
      name: video.name,
      description: video.description,
      thumbnails: [video.poster],
      contentUrl: video.src,
      duration: video.duration,
      uploadDate: video.uploadDate,
      creatorName: "creatorName" in video ? video.creatorName : undefined,
    })],
  };
}